var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.217 40.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.217 20.2l-20.2 20.2L0 37.383 17.183 20.2 0 3.017 3.017 0z",
    fill: "#1c5f8a"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMy4yMTcgNDAuNCI+CiAgPHBhdGggZD0iTTIzLjIxNyAyMC4ybC0yMC4yIDIwLjJMMCAzNy4zODMgMTcuMTgzIDIwLjIgMCAzLjAxNyAzLjAxNyAweiIgZmlsbD0iIzFjNWY4YSIvPgo8L3N2Zz4=";
export { SvgArrow as ReactComponent };